const SET_REUNIONSELECTED = "SET_REUNIONSELECTED";
const RESET_REUNIONSELECTED = "RESET_REUNIONSELECTED";

const dataInitial = {
  reunionSelected: null,
};

export default function reducer(state = dataInitial, action) {
  switch (action.type) {
    case SET_REUNIONSELECTED: {
      return {
        ...state,
        reunionSelected: action.payload,
      };
    }
    case RESET_REUNIONSELECTED: {
      return {
        ...state,
        reunionSelected: null,
      };
    }
    default: {
      return state;
    }
  }
}

export function setReunionData(reunion) {
  return {
    type: SET_REUNIONSELECTED,
    payload: reunion,
  };
}
export function resetReunionData() {
  return {
    type: RESET_REUNIONSELECTED,
  };
}
